export const trackSponsoredListingImpressions = (data) => {
    var _a;
    (_a = data === null || data === void 0 ? void 0 : data.hotelSearchResults) === null || _a === void 0 ? void 0 : _a.hotels.forEach((hotel) => {
        const { isSponsored, impressionUrl } = (hotel === null || hotel === void 0 ? void 0 : hotel.pricingSummary) || {};
        if (isSponsored && impressionUrl) {
            fetch(impressionUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        }
    });
};
